import React, { useState } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { TextField, Button, Box, Typography } from "@mui/material";
import { CONFIG } from "../config";

function Password() {
  const location = useLocation();
  const navigate = useNavigate();
  const isNewPasswordRequired = location.state?.newPasswordRequired;
  const emailFromState = location.state?.email;
  const sessionFromState = location.state?.session;

  const [email, setEmail] = useState(emailFromState || "");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  if (!isNewPasswordRequired || !emailFromState) {
    navigate("/login");
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!email.trim()) newErrors.email = true;
    if (!password.trim()) newErrors.password = true;
    if (password !== confirmPassword || !confirmPassword.trim())
      newErrors.confirmPassword = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    if (!sessionFromState) {
      alert("Sesión expirada. Vuelve a iniciar sesión.");
      navigate("/login");
      return;
    }

    setIsLoading(true);
    try {
      const res = await axios.post(
        CONFIG.BACKEND_URL + "/backend/complete-new-password",
        {
          email: email.trim(),
          newPassword: password,
          session: sessionFromState,
        }
      );
      const data = res.data;
      if (data?.code === 200) {
        const token = data.idToken || data.accessToken || data.token;
        if (token) localStorage.setItem("token", token);
        if (data.username) localStorage.setItem("username", data.username);
        alert("Contraseña actualizada. Ya puedes usar la aplicación.");
        navigate("/dashboard", { state: { email: data.email || email } });
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "No se pudo actualizar la contraseña.";
      alert("Error: " + msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex animation-container bg">
      <div className="m-auto box-form">
        <Typography variant="h5" gutterBottom>
          Establecer nueva contraseña
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Debes elegir una nueva contraseña para tu cuenta.
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", width: "100%", maxWidth: 400 }}
        >
          <TextField
            fullWidth
            label="Correo electrónico"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email ? "Requerido" : ""}
            sx={{ mb: 2 }}
            disabled={!!emailFromState}
          />
          <TextField
            fullWidth
            label="Nueva contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!errors.password}
            helperText={errors.password ? "Requerido" : ""}
            sx={{ mb: 2 }}
            disabled={isLoading}
          />
          <TextField
            fullWidth
            label="Confirmar contraseña"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={!!errors.confirmPassword}
            helperText={
              errors.confirmPassword ? "Las contraseñas no coinciden" : ""
            }
            sx={{ mb: 2 }}
            disabled={isLoading}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
          >
            {isLoading ? "Guardando..." : "Establecer contraseña"}
          </Button>
          <Typography sx={{ mt: 2 }}>
            <Link to="/login">Volver al inicio de sesión</Link>
          </Typography>
        </Box>
      </div>
    </div>
  );
}

export default Password;
